export const JOB_STATUS = {
  WAITING: "waiting",
  PROCESSING: "processing",
  REJECT: "reject",
  AUTHENING: "authening",
  DONE: "done",
  COMPLETE: "complete",
};

const data = [
  { key: JOB_STATUS.WAITING, label: "WAITING" },
  { key: JOB_STATUS.PROCESSING, label: "PROCESSING" },
  { key: JOB_STATUS.REJECT, label: "REJECT" },
  { key: JOB_STATUS.AUTHENING, label: "AUTHENING" },
  { key: JOB_STATUS.DONE, label: "DONE" },
  { key: JOB_STATUS.COMPLETE, label: "COMPLETE" },
];

export default data;

export const JobStatusComponent = ({ value }) => {
  const message = data.find((f) => f.key === value)?.label ?? "";
  let badgeType = "";
  switch (value) {
    case JOB_STATUS.WAITING:
      badgeType = "warning";
      break;
    case JOB_STATUS.DONE:
      badgeType = "primary";
      break;
    case JOB_STATUS.PROCESSING:
      badgeType = "success";
      break;
    case JOB_STATUS.AUTHENING:
      badgeType = "info";
      break;
    case JOB_STATUS.REJECT:
      badgeType = "danger";
      break;
    case JOB_STATUS.COMPLETE:
      badgeType = "secondary";
      break;
  }

  return <div className={`badge badge-${badgeType}`}>{message}</div>;
};
